module.exports = __webpack_public_path__ + "static/scale-model-of-museum-of-north-texas-history-in-wichita-falls-texas-e22146b43ad38edb4593a64865bf37ca.png";